<template>
  <div id="ServicesCard" :class="getTileClass">
    <div class="backgroundContainer" :style="{ backgroundImage: 'url(' + this.item.featured_img + ')' }"></div>
    <div class="unexpandedOverlay" @click="handleOverlayClick" :style="{backgroundImage: `url('/img/vectors/blue.png')`}">
      <div class="textContainer" :style="{paddingBottom: sizing.subtitle}">
<!--          <div class="subtitle" :style="{fontSize: sizing.subtitle}">{{serviceData.subTitle}}</div>-->
          <div :style="{fontSize: sizing.tileLabel, lineHeight: sizing.tileLabel}" class="tileLabel lightCardText">{{this.item.label}}</div>
      </div>
    </div>
    <div class="expandedOverlay" :style="{width: standardTileWidth * increaseFactor +'px', backgroundImage: 'url(' + this.item.featured_img + ')'}" >
      <div class="expandedOverlayInner" :style="{paddingTop: sizing.overlayTop}">
        <div class="expandedTitle" :style="{fontSize: sizing.expandedTitle}">{{this.item.label}}</div>
        <div class="btnRow my-3">
          <div class="moreButton"
               @click="goToContent"
               :style="{fontSize: sizing.moreButton, height: sizing.moreButtonHeight, width: sizing.moreButtonWidth}">
            More Details
          </div>
        </div>
        <div class="description" :style="{fontSize: sizing.description}">{{item.description}}</div>
      </div>

    </div>
  </div>
</template>

<script>

import axios from "axios";
import config from "@/config/constants";

export default {
  name: "ServicesCard",
  props: ["item","expanded","tileHeight","stopExpand","increaseFactor","standardTileWidth"],
  methods: {
    submitSamlResponse(samlResponse, acsUrl) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = acsUrl;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'SAMLResponse';
      input.value = samlResponse;

      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    },
    async getBenefitsUrl() {
      if(this.$store.getters.skin === 25 && this.$store.getters.user.access_code_user){
        window.location.href = 'https://spectrumbenefits.benefithub.com/';
      } else {
        const slPayload = {
          user_id: this.$store.getters.user_id,
        };
        let slRes = await axios.post(
            config.api_env + "/application/api/p/saml/sso",
            slPayload,
            config.options
        );
        this.submitSamlResponse(slRes.data.samlResponse, slRes.data.acsUrl);
      }
    },
    goToContent() {
      if(this.item.internal_link) {
        window.open(this.item.internal_link, "_blank");
      } else if (this.item.item_slug){
        this.$router.push({ name: this.item.item_slug });
      } else if(this.$store.getters.skin === 30 && this.serviceData.item_slug === 'rewards') {
        this.getBenefitsUrl();
      } else {
        this.$router.push({name: this.serviceData.item_slug})
      }
    },
    handleOverlayClick() {
      if(!this.stopExpand) return;
      this.$router.push({name: this.item.item_slug})
    }
  },
  computed: {
    sizing() {
        return {
          subtitle: Math.floor(this.tileHeight * 0.03) + 'px',
          tileLabel:  Math.floor(this.tileHeight * 0.0525) + 'px',
          moreButton: Math.floor(this.tileHeight * 0.0405) + 'px',
          moreButtonHeight: Math.floor(this.tileHeight * 0.085) + 'px',
          moreButtonWidth: Math.floor(this.tileHeight * 0.35) + 'px',
          expandedTitle: Math.floor(this.tileHeight * 0.075) + 'px',
          plusIcon: Math.floor(this.tileHeight * 0.075) + 'px',
          description: Math.floor(this.tileHeight * 0.045) + 'px',
          overlayTop: Math.floor(this.tileHeight * 0.3) + 'px'
        }
    },
    getTileClass() {
      let classStr = this.item.item_slug;
      if(this.expanded && !this.stopExpand) classStr += " expanded";
      if(this.stopExpand) classStr += " stopExpand"
      return classStr;
    },
  }
}

</script>
<style lang="less">
#ServicesCard {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  .lightCardText {
    color: white;
  }
  .expandedBackground {
    position: absolute;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    //border-radius: 15px;
    z-index: 0;
  }
  .backgroundContainer {
    position: absolute;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 15px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 1;
    //transition: opacity 0.25s ease-in;
    //transition-delay: 0.5s;
  }
  .unexpandedOverlay {
    opacity: 1;
    height: 80%;
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 3;
    //transition-delay: 0.85s;
    transition: opacity 1s ease-in-out 1s;
    //border-radius: 15px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: bottom;
    .iconHolder {
      width: 30%;
      position: absolute;
      bottom: 0;
      right: 0;
      img {
        width: 45%;
        display: block;
        margin-left: auto;
        margin-right: auto;
      }
    }
    .textContainer {
      width: 70%;
      height: fit-content;
      opacity: 1;
      color: #122130;
      position: absolute;
      bottom: 0;
      left: 5%;
      z-index: 4;
      display: flex;
      flex-direction: column;
      .tileLabel {
        font-family: FilsonProBold, Arial, Helvetica, sans-serif;
      }
    }
  }
  .expandedOverlay {
    opacity: 0;
    //transition: none;
    //transition-delay: 0.25s;
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    color: white;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    //border-radius: 15px;
    position: relative;
    .expandedOverlayInner {
      position: absolute;
      padding-left: 10%;
      background: linear-gradient(83.35deg, #000000 16.67%, rgba(0, 0, 0, 0) 98.17%);
      width: 100%;
      height: 100%;
    }
    //
    .expandedTitle {
      font-family: FilsonProBold, Arial, Helvetica, sans-serif;
      width: 75%;
    }
    .btnRow {
      align-items: center;
      display: flex;
      .moreButton {
        width: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 30px;
        //background: linear-gradient(90deg, #112231 0%, #937FF8 100%);
        //background: linear-gradient(90deg, #ED3A75 0%, #6A356A 100%);

      }
      i {
        margin-left: 20px;
        color: #FFFFFFAB;
      }
    }
    .description {
      width: 60%;
    }
  }
  //stopExpand
  &.stopExpand {
    .unexpandedOverlay {
      cursor: pointer;
    }
  }
  //expanded
  &.expanded {
    .backgroundContainer {
      opacity: 0;
      //transition: none;
      //transition-delay: 0s;
    }
    .expandedOverlay {
      opacity: 1;
      //transition: opacity 0.5s ease-in;
      //transition-delay: 0.75s;
    }
    .unexpandedOverlay {
      opacity: 0;
      z-index: -1;
      transition-delay: 0s !important;
    }
  }
  //  service specific classes
  &.cahms, &.cmh, &.beCalm, &.fitness, &.soundSpace,&.nutrition, &.wellbeing, &.rewards {
    .unexpandedOverlay {
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom;
    }
  }
  &.eap {
    .unexpandedOverlay {
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom;
    }
  }
  &.digitalClinicsGeneric {
    .unexpandedOverlay {
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom;
    }
  }
  &.wellbeingSeries {
    .unexpandedOverlay {
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom;
    }
  }
  &.totalMentalHealth, &.bookAService {
    .unexpandedOverlay {
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom;
    }
  }
  &.digitalGym {
    .unexpandedOverlay {
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom;
    }
    .backgroundContainer {
      background-position: 92%;
    }
  }
}
</style>